import React, { useContext } from "react";
import styled from 'styled-components';
import Menu from "header/Menu";

const StyledBar = styled.div`
  width: 100%;
  height: ${props => props.$heights[0]}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #323332;
  box-sizing: border-box;

  @media (max-width: 768px) {
    height: ${props => props.$heights[2]}px;
  }
`;

const NavBar = ({ heights }) => {
  return (
    <div className="NavBar">
      <StyledBar $heights={heights}>
        <Menu />
      </StyledBar>
    </div>
  );
};

export default NavBar;